import { Anchor, Stack, Text } from '@mantine/core'

export const UncancellableBookingNotice = () => {
  return (
    <Stack>
      <Text size="sm">
        You cannot cancel a booking less than 2 business days before the event
        through the app.
      </Text>
      <Text size="sm">
        If you need to cancel the event, reach out directly via text or call at{' '}
        <Anchor href="tel:(213) 376-3480" size="sm">
          (213) 376-3480
        </Anchor>
        . Please note our business hours are 8AM–6PM EST; please text us outside
        of these hours.
      </Text>
    </Stack>
  )
}
